import theme from '@src/theme';

export const size = (width: number, height: number) => ({
  ...(height
    ? {
        width,
        height,
      }
    : {
        width,
        height: width,
      }),
});

type JustifyContentProperty =
  | 'center'
  | 'start'
  | 'end'
  | 'flex-start'
  | 'flex-end'
  | 'left'
  | 'right'
  | 'normal'
  | 'space-between'
  | 'space-around'
  | 'space-evenly'
  | 'stretch'
  | 'safe center'
  | 'unsafe center'
  | 'inherit'
  | 'initial'
  | 'revert'
  | 'revert-layer'
  | 'unset';

type AlignItemsProperty =
  | 'normal'
  | 'stretch'
  | 'center'
  | 'start'
  | 'end'
  | 'flex-start'
  | 'flex-end'
  | 'self-start'
  | 'self-end'
  | 'anchor-center'
  | 'first baseline'
  | 'baseline'
  | 'last baseline'
  | 'safe center'
  | 'unsafe center'
  | 'inherit'
  | 'revert'
  | 'revert-layer'
  | 'unset'
  | 'initial';

export const dFlex = (
  justifyContent?: JustifyContentProperty,
  alignItems?: AlignItemsProperty,
) => ({
  display: 'flex',
  justifyContent: justifyContent || 'center',
  alignItems: alignItems || 'center',
});

export const scrollBar = {
  '&::-webkit-scrollbar': {
    width: '4px',
    height: '4px',
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    background: theme.secondary.s2,
    borderRadius: '100px',
  },
};
